import { readCookie } from "@/utils/cookies";
import { PRODUCT_IMAGES_CORE } from "@/utils/imagesMapCore";

export type QuizResurfaceProduct = {
  sku?: string;
  name?: string;
  fullname?: string;
  description?: string;
  imageUrl?: string;
  price?: number;
  bundledPrice?: number;
  promoPrice?: number;
  promoName?: string;
  promoSavings?: string;
  promoUseDpaKey?: boolean;
  purchaseSource?: string;
};

const ADV_COPY: Record<string, { image: string; title: string; description: string }> = {
  ADV1: {
    image: PRODUCT_IMAGES_CORE.ADV1.label2,
    title: "Women",
    description:
      "Our physician-formulated hair growth supplement is designed for women 18-44 experiencing hair thinning.",
  },
  ADV3: {
    image: PRODUCT_IMAGES_CORE.ADV3.label2,
    title: "Women",
    description:
      "Our physician-formulated hair growth supplement is designed for women 18-44 experiencing hair thinning.",
  },
  ADV6: {
    image: PRODUCT_IMAGES_CORE.ADV6.label2,
    title: "Women",
    description:
      "Our physician-formulated hair growth supplement is designed for women 18-44 experiencing hair thinning.",
  },
};

const remapLegacySku = (sku: string) => {
  const match = /^(WOM|VEG)(\d+)$/i.exec(sku);
  return match ? `ADV${match[2]}` : sku;
};

export const readQuizResurfaceProduct = (): QuizResurfaceProduct | null => {
  const raw = readCookie("resurface-quiz");
  if (!raw) return null;
  try {
    const data = JSON.parse(decodeURIComponent(raw)) as QuizResurfaceProduct | null;
    if (!data?.sku) return data;

    const advSku = remapLegacySku(data.sku);
    if (advSku !== data.sku) {
      const advProduct = ADV_COPY[advSku];
      data.sku = advSku;
      if (advProduct) {
        data.imageUrl = advProduct.image;
        data.name = advProduct.title;
        data.fullname = advProduct.title;
        data.description = advProduct.description;
      }
    }
    return data;
  } catch {
    return null;
  }
};
